import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TagRoundingStyle, TagTheme } from './interfaces';

@Component({
  selector: 'fcom-tag',
  styleUrls: ['tag.component.scss'],
  templateUrl: 'tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TagComponent {
  readonly TagTheme = TagTheme;
  readonly TagRoundingStyle = TagRoundingStyle;

  theme = input(TagTheme.DEFAULT);
  roundingStyle = input(TagRoundingStyle.DEFAULT);
  disabled = input(false);
}
